import { render, staticRenderFns } from "./ChatNotification.vue?vue&type=template&id=659c8d00"
import script from "./ChatNotification.vue?vue&type=script&lang=js"
export * from "./ChatNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports